<template>
    <div class="ncrypt-message">
        <div v-if="message">
            <ion-grid class="ion-no-padding">
                <ion-row>
                    <ion-col size-xs="12">
                        <ion-list lines="none" inset="false" style="margin-bottom: 0;">
                            <ion-item class="ion-no-padding">
                                <ion-text>
                                    <h4>{{ message ? message.subject : '' }}</h4>
                                </ion-text>

                                <ion-chip slot="end" outline="true">
                                    <ion-icon ios='calendar' md="calendar"></ion-icon>

                                    <ion-label>{{ message.sent_at_short }}</ion-label>
                                </ion-chip>
                            </ion-item>

                            <ion-item class="ion-no-padding">
                                <ion-note slot="start">{{ $t('ncrypt.write_message.sender_from_label') }}</ion-note>

                                <ion-label>{{ message.sender.email }}</ion-label>
                            </ion-item>
                        </ion-list>
                    </ion-col>
                </ion-row>
            </ion-grid>

            <div>
                <ion-card>
                    <ion-card-header>
                        <ion-card-title>{{ $t('ncrypt.incoming_mail_body_title') }}</ion-card-title>
                    </ion-card-header>

                    <ion-card-content v-dompurify-html="message ? message.body : ''"
                                      class="incoming-mail-message"/>
                </ion-card>

                <ion-item lines="none" v-if="message.attachments.length">
                    <incoming-mail-attachment v-for="(attachment, i) in message.attachments"
                                              v-bind:key="`${i}-${attachment.id}`"
                                              :attachment="attachment"/>
                </ion-item>
            </div>
        </div>

        <message-skeleton v-else/>
    </div>
</template>

<script>
    import MessageSkeleton from "./MessageSkeleton";
    import IncomingMailAttachment from "@/components/IncomingMailAttachment";

    export default {
        name: "IncomingMailMessage",
        components: {IncomingMailAttachment, MessageSkeleton},
        props: {
            message: {type: Object},
        },
    }
</script>

<style lang="scss">
    ion-card .incoming-mail-message img {
        width: auto;
    }
</style>
